import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading:true,
    empresa:{
      abreviatura:"",
      correo:"",
      direccion:"",
      fan_page:"",
      horario_atencion:"",
      logo:"",
      razon_social:"",
      ruc:"",
      telefonos:"",
      ubigeo:"",
    },
  },
  mutations: {
    setLoading:(state,value)=>{
      Vue.set(state,'loading',value);
    },
    setEmpresa:(state,obj)=>{
      Vue.set(state,'empresa',obj);
      localStorage.setItem('StationCMVSM'+process.env.VUE_APP_COMPANY, JSON.stringify(obj));
      //console.clear();
    },
  },
  actions: {
    loadObjEmpresa({commit, dispatch, getters}){
      let ObjEmpresa= localStorage.getItem('StationCMVSM'+process.env.VUE_APP_COMPANY);
      if(ObjEmpresa){
        ObjEmpresa = JSON.parse(ObjEmpresa);
        commit('setEmpresa',ObjEmpresa);
      }
    },
  },
  modules: {
  }
})
